import { TriangleAlert } from 'lucide-react'

interface BudgetMoveNoteProps {
    note?: string | null
}

/**
 * Shown next to an ad set that was added with a budget move that was not applied or may still be running: no budget
 * was taken from another ad set for it (yet), so it must not be switched on. Nothing for other ad sets.
 */
const BudgetMoveNote = ({ note = null }: BudgetMoveNoteProps) => {
    if (!note) return null

    return (
        <span
            data-testid="budget-move-note"
            className="tw:inline-flex tw:shrink-0 tw:items-center tw:gap-1 tw:rounded tw:border tw:border-yellow-300 tw:px-1.5 tw:py-0.5 tw:text-xs tw:whitespace-nowrap tw:text-yellow-300"
        >
            <TriangleAlert size={12} aria-hidden="true" />
            {note}
        </span>
    )
}

export default BudgetMoveNote
